import { SvgIcon } from "@mui/material"

import { ReactComponent as ErrorIcon } from "./error.svg"

export const StatusErrorIcon = (props) => {
    return (
        <SvgIcon component={ErrorIcon} {...props} inheritViewBox />
    )
}